<template>
    <div class="whiteBg main">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="教师管理" name="2">
                <div class="box box-align-center box-pack-between mt12 tab-teacher">
                    <div class="box box-align-center">
                        <div class="box box-align-center tabt-name">
                            教师姓名：<el-input v-model="userName" placeholder="请输入教师姓名" clearable></el-input>
                        </div>
                        <div class="box box-align-center ml24 tabt-phone">
                            手机号：<el-input v-model="userTel" placeholder="请输入手机号" clearable></el-input>
                        </div>
                    </div>
                    <div class="box box-align-center tabt-btn">
                        <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
                        <el-button type="primary" icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </div>
                <el-button type="warning" icon="el-icon-download" class="main-export"
                    @click="onRowAddButtonClick(2)">导出</el-button>
                <div class="mt12">
                    <dy-table :columns="columns" :tableData="tableData" v-loading="tableLoading" :isShowPager="true"
                        :total="total" :pageNum="currentPage" :pageSize="pageSize" @current-change="onCurrentChange"
                        @size-change="onSizeChange">
                    </dy-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="学生管理" name="1">
                <div class="box box-align-center box-pack-between mt12 tab-teacher">
                    <div class="box box-align-center">
                        <div class="box box-align-center tabt-name">
                            学生姓名：<el-input v-model="userName" placeholder="请输入学生姓名" clearable></el-input>
                        </div>
                        <div class="box box-align-center ml24 tabt-phone">
                            手机号：<el-input v-model="userTel" placeholder="请输入手机号" clearable></el-input>
                        </div>
                    </div>
                    <div class="box box-align-center ml24 tabt-btn">
                        <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
                        <el-button type="primary" icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </div>
                <el-button type="warning" icon="el-icon-download" class="main-export"
                    @click="onRowAddButtonClick(1)">导出</el-button>
                <div class="mt12">
                    <dy-table :columns="stuColumns" :tableData="tableData" v-loading="tableLoading" :isShowPager="true"
                        :total="total" :pageNum="currentPage" :pageSize="pageSize" @current-change="onCurrentChange"
                        @size-change="onSizeChange">
                    </dy-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="家长管理" name="3">
                <div class="box box-align-center box-pack-between mt12 tab-teacher">
                    <div class="box box-align-center">
                        <div class="box box-align-center tabt-name">
                            用户真实姓名：<el-input v-model="userName" placeholder="请输入用户真实姓名" clearable></el-input>
                        </div>
                        <div class="box box-align-center ml24 tabt-phone">
                            手机号：<el-input v-model="userTel" placeholder="请输入手机号" clearable></el-input>
                        </div>
                    </div>
                    <div class="box box-align-center ml24 tabt-btn">
                        <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
                        <el-button type="primary" icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </div>
                <el-button type="warning" icon="el-icon-download" class="main-export"
                    @click="onRowAddButtonClick(3)">导出</el-button>
                <div class="mt12">
                    <dy-table :columns="parColumns" :tableData="tableData" v-loading="tableLoading" :isShowPager="true"
                        :total="total" :pageNum="currentPage" :pageSize="pageSize" @current-change="onCurrentChange"
                        @size-change="onSizeChange">
                    </dy-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog title="" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false">
            <div class="font-20 mb12 main-black dia-title">账号信息</div>
            <el-form>
                <el-row>
                    <el-col :span="8" v-if="objDetail.userType == 2">
                        <el-form-item label="教师真实姓名：">
                            <el-input v-model="objDetail.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-else-if="objDetail.userType == 1">
                        <el-form-item label="学生真实姓名：">
                            <el-input v-model="objDetail.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-else-if="objDetail.userType == 3">
                        <el-form-item label="用户真实姓名：">
                            <el-input v-model="objDetail.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号：">
                            <el-input v-model="objDetail.userTel"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="创建时间：">
                            <el-input v-model="objDetail.createTime"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="昵称：">
                            <el-input v-model="objDetail.userNickname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="性别：">
                            <el-input v-model="objDetail.gender"></el-input>
                            <!-- <el-select v-model="objDetail.gender" placeholder="请选择性别">
                                <el-option v-for="item in sexList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="生日：">
                            <el-input v-model="objDetail.birthday"></el-input>
                            <!-- <el-date-picker v-model="objDetail.birthday" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="所属学校/组织：">
                            <el-input v-model="objDetail.schoolName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="lastest-study" v-if="objDetail.learningContents && objDetail.learningContents.length > 0">
                <div class="font-20 mb12 main-black dia-title">最近在学</div>
                <div class="whiteBg lasts-list">
                    <div class="mb24 lastl-title">近30天活跃天数：{{ objDetail.activityDay }}天</div>
                    <div class="lastl-ul">
                        <div class="box box-align-center box-pack-between lastlu-li"
                            v-for="(item, index) in objDetail.learningContents" :key="index">
                            <div class="lastlul-left">{{ item.title }}</div>
                            <div class="lastlul-right">{{ item.dateLineForBgUser }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <!-- <el-button type="primary" plain @click="saveData">保存</el-button> -->
                <el-button type="danger" plain @click="() => dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import DyTable from '@/components/common/dytable'
import { queryUserInfo, findAllSchool, updateUserDetail, queryUserDetails, setAdmin } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, formatJson } from '@/utils/utils';
import { sexList } from '@/utils/commonData'
var that = null;
export default {
    name: 'userManagement',
    components: {},
    data() {
        const { showDetail, doDisable, setAdmin } = this;
        return {
            activeName: '2',
            schoolList: [],
            value: '',
            sexList,
            tableLoading: true,
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'userName',
                    title: '教师真实姓名'
                },
                {
                    key: 'secretTel',
                    title: '手机号',
                    render: ({ row }) => {
                        return (
                            <el-tooltip class="item" effect="dark" content={row.userTel} placement="top-start">
                                <el-button>{row.secretTel}</el-button>
                            </el-tooltip>
                        );
                    }
                },
                {
                    key: 'schoolName',
                    title: '所属学校/组织',
                    render: ({ row }) => {
                        return (
                            <div>
                                {row.schoolName}{row.isAdmin == 1 && '(管理员)'}
                            </div >
                        );
                    }
                },
                {
                    key: 'createTime',
                    title: '创建时间'
                },
                {
                    key: 'userCerResult',
                    title: '实名认证',
                    render: ({ row }) => {
                        if (row.userCerResult == 1) {
                            return (
                                <div>认证中</div>
                            );
                        }
                        if (row.userCerResult == 2) {
                            return (
                                <div>认证成功</div>
                            );
                        }
                        if (row.userCerResult == 3) {
                            return (
                                <div>认证失败</div>
                            );
                        }
                    }
                },
                {
                    key: 'cerFlg',
                    title: '教师认证',
                    render: ({ row }) => {
                        if (row.cerFlg == 1) {
                            return (
                                <div>未认证</div>
                            );
                        }
                        if (row.cerFlg == 2) {
                            return (
                                <div>审核中</div>
                            );
                        }
                        if (row.cerFlg == 3) {
                            return (
                                <div>审核通过</div>
                            );
                        }
                        if (row.cerFlg == 4) {
                            return (
                                <div>审核不通过</div>
                            );
                        }
                    }
                },
                {
                    key: 'userStatus',
                    title: '状态',
                    render: ({ row }) => {
                        if (row.userStatus == 1) {//启用
                            return (
                                <div>已启用</div>
                            );
                        } else {
                            return (
                                <div>已禁用</div>
                            );
                        }
                    }
                },
                {
                    key: '',
                    title: '操作',
                    render: ({ row }) => {
                        if (row.schoolId && row.userCerResult == 2 && row.isAdmin == 0) {
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => setAdmin(row)}>成为管理员</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>
                                        {row.userStatus == 1 && '禁用'}
                                        {row.userStatus == 2 && '启用'}
                                    </el-link>
                                </div>
                            );
                        } else {
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>
                                        {row.userStatus == 1 && '禁用'}
                                        {row.userStatus == 2 && '启用'}
                                    </el-link>
                                </div >
                            );
                        }
                    }
                },
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,

            stuColumns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'userName',
                    title: '学生真实姓名'
                },
                {
                    key: 'secretTel',
                    title: '手机号',
                    render: ({ row }) => {
                        return (
                            <el-tooltip class="item" effect="dark" content={row.userTel} placement="top-start">
                                <el-button>{row.secretTel}</el-button>
                            </el-tooltip>
                        );
                    }
                },
                {
                    key: 'userStatus',
                    title: '状态',
                    render: ({ row }) => {
                        if (row.userStatus == 1) {//启用
                            return (
                                <div>已启用</div>
                            );
                        } else {
                            return (
                                <div>已禁用</div>
                            );
                        }
                    }
                },
                {
                    key: 'createTime',
                    title: '创建时间'
                },
                {
                    key: '',
                    title: '操作',
                    render: ({ row }) => {
                        if (row.userStatus == 1) {//启用
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>禁用</el-link>
                                </div>
                            );
                        } else {
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>启用</el-link>
                                </div>
                            );
                        }
                    }
                },
            ],
            parColumns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'userName',
                    title: '用户真实姓名'
                },
                {
                    key: 'secretTel',
                    title: '手机号',
                    render: ({ row }) => {
                        return (
                            <el-tooltip class="item" effect="dark" content={row.userTel} placement="top-start">
                                <el-button>{row.secretTel}</el-button>
                            </el-tooltip>
                        );
                    }
                },
                {
                    key: 'userStatus',
                    title: '状态',
                    render: ({ row }) => {
                        if (row.userStatus == 1) {//启用
                            return (
                                <div>已启用</div>
                            );
                        } else {
                            return (
                                <div>已禁用</div>
                            );
                        }
                    }
                },
                {
                    key: 'createTime',
                    title: '创建时间'
                },
                {
                    key: '',
                    title: '操作',
                    render: ({ row }) => {
                        if (row.userStatus == 1) {//启用
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>禁用</el-link>
                                </div>
                            );
                        } else {
                            return (
                                <div>
                                    <el-link type="primary" style="margin-left:12px" onClick={() => showDetail(row)}>详情</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDisable(row)}>启用</el-link>
                                </div>
                            );
                        }
                    }
                },
            ],
            dialogVisible: false,
            schoolId: '',
            userName: '',
            userTel: '',
            userType: 2,
            objDetail: {},//详情数据
            levelList: [],//导出数据

            tHeader1: ['教师真实姓名', '手机号', '所属学校/组织', '创建时间', '实名认证', '教师认证', '状态'],
            tValue1: ['userName', 'userTel', 'schoolName', 'createTime', 'userCerResult', 'cerFlg', 'userStatus'],

            tHeader2: ['学生真实姓名', '手机号', '所属学校/组织', '状态', '创建时间'],
            tValue2: ['userName', 'userTel', 'schoolName', 'userStatus', 'createTime'],

            tHeader3: ['用户真实姓名', '手机号', '状态', '创建时间'],
            tValue3: ['userName', 'userTel', 'userStatus', 'createTime'],
            userCerList: ['认证中', '认证中', '认证中'],
            teacherCerList: ['未认证', '审核中', '审核通过', '审核不通过'],
        };
    },
    components: {
        DyTable
    },
    mounted() {
        that = this;
        that.getList();
        that.getSchoolList();
    },
    computed: {
        headers() {
            return {
                'menu_id': localStorage.getItem('menu_id'),
                'bg_token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        },
    },
    methods: {

        setAdmin(row) {
            that.$confirm('确认要将此教师设置成管理员吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let param = {
                    userId: row.userId,
                    schoolId: row.schoolId,
                }
                console.log('param', param);
                that.tableLoading = true;
                setAdmin(encrypt(JSON.stringify(param))).then((res) => {
                    that.tableLoading = false;
                    if (res.result == 1) {
                        this.$message({
                            showClose: true,
                            message: '操作成功',
                            type: 'success',
                        });
                        that.getList();
                    } else {
                        that.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });

            });
        },
        // 导出
        onRowAddButtonClick(userType) {
            this.isloading = true
            var query = {
                schoolId: '',
                userName: that.userName,
                userTel: that.userTel,
                userType: userType,
                needPage: false,
            };
            const queryData = encrypt(JSON.stringify(query))
            queryUserInfo(queryData).then(resp => {
                that.isloading = false;
                var data = JSON.parse(decrypt(resp.data.replace(/[\r\n]/g, '')));
                that.levelList = data.map(item => {
                    return {
                        ...item,
                        createTime: formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss'),
                        userStatus: item.userStatus == 1 ? '已启用' : '已禁用',
                        userCerResult: item.userCerResult != undefined ? that.userCerList[item.userCerResult] : '',
                        cerFlg: item.cerFlg != undefined ? that.teacherCerList[item.cerFlg] : '',
                    }
                });
                let tValue = [];
                let tHeader = [];
                switch (parseInt(userType)) {
                    case 2:
                        tValue = that.tValue1;
                        tHeader = that.tHeader1;
                        break;
                    case 1:
                        tValue = that.tValue2;
                        tHeader = that.tHeader2;
                        break;
                    case 3:
                        tValue = that.tValue3;
                        tHeader = that.tHeader3;
                        break;
                    default:
                        break;
                }
                import('@/components/ExportExcel/Export2Excel').then(excel => {
                    const data = formatJson(tValue, that.levelList);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.filename,
                        autoWidth: true,
                        bookType: 'xlsx'
                    });
                });
            }, () => {
                this.isloading = false
            })
            this.filename = '用户管理';
        },
        doDisable(obj) {
            let str = obj.userStatus == 1 ? '禁用' : '启用';
            console.log('str', str);
            that.$confirm('确认要' + str + '此用户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.updateUserDetail(obj);
            })
        },
        //更新信息
        updateUserDetail(item) {
            let obj = {
                email: '',
                gender: item.gender == '男' ? ' 1' : '2',
                schoolId: item.schoolId || '',
                userId: item.userId,
                userName: item.userName || '',
                userNickname: item.userNickname || '',
                userStatus: item.userStatus == 1 ? 2 : 1,
                userTel: item.userTel,
            }
            console.log("getList", obj);
            let data = encrypt(JSON.stringify(obj));
            updateUserDetail(data).then((res) => {
                if (res.result == 1) {
                    that.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    that.getList();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 用户详情
        showDetail(obj) {
            console.log(obj);
            let info = {
                userId: obj.userId
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryUserDetails(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('课程列表', ress);
                    that.objDetail = ress;
                    that.objDetail.createTime = ress.createTime ? formatDate(new Date(ress.createTime), 'yyyy-MM-dd hh:mm:ss') : '';
                    that.objDetail.birthday = ress.birthday ? formatDate(new Date(ress.birthday), 'yyyy-MM-dd hh:mm:ss') : '';
                    that.objDetail.gender = ress.gender == 1 ? '男' : '女';
                    that.objDetail.learningContents = that.objDetail.learningContents.map(item => {
                        return {
                            ...item,
                            dateLineForBgUser: item.dateLineForBgUser ? formatDate(new Date(item.dateLineForBgUser), 'yyyy-MM-dd hh:mm:ss') : '',
                        }
                    });
                    that.dialogVisible = true;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        saveData() {
            that.updateUserDetail(that.objDetail);
        },
        onSizeChange(num) {
            console.log(num);
        },
        onCurrentChange(val) {
            that.tableLoading = true;
            that.currentPage = val;
            that.getList();
        },
        handleClick(tab, event) {
            console.log(tab.index);
            let index = tab.index;
            switch (parseInt(index)) {
                case 0:
                    that.userType = 2;
                    break;
                case 1:
                    that.userType = 1;
                    break;
                case 2:
                    that.userType = 3;
                    break;
                default:
                    break;
            }
            that.getList();
        },
        //重置列表
        resetList() {
            that.userTel = '';
            that.userName = '';
            that.currentPage = 1;
            that.getList();
        },
        //获取列表
        getList() {
            let obj = {
                schoolId: that.schoolId,
                userName: that.userName,
                userTel: that.userTel,
                userType: that.userType,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true,
            }
            console.log("getList", obj);
            let data = encrypt(JSON.stringify(obj));
            queryUserInfo(data).then((res) => {
                var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                console.log("用户列表", ress);
                if (ress && ress.list) {
                    that.tableData = ress.list.map(item => {
                        return {
                            ...item,
                            createTime: formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss')
                        }
                    });
                    that.pageSize = ress.pageSize;
                    that.total = ress.total;
                } else {
                    that.tableData = [];
                    that.total = 0;
                }
                that.tableLoading = false;
            });
        },
        //获取学校列表
        getSchoolList() {
            let obj = {}
            console.log("getList", obj);
            let data = encrypt(JSON.stringify(obj));
            findAllSchool(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("学校列表", ress);
                    that.schoolList = ress;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
};
</script>

<style lang='scss' scoped>
/deep/.el-tooltip {
    border: none !important;
    background-color: transparent;

}

.el-color-picker__icon,
.el-input,
.el-textarea {
    width: initial;
}

.main {
    white-space: nowrap;
    padding: 12px;

    .main-export {
        margin-top: 12px;
    }

    .tab-teacher {
        padding: 0 24px;
    }

    .teacher-cerImgs {
        .teri-one {
            width: 128px;
            height: 164px;
            margin-right: 35px;
            border: 1px solid #e6e6e6;
        }
    }

    .lastl-ul {
        width: 80%;
        height: 200px;
        overflow-y: scroll;

        .lastlu-li {
            padding: 0 40px;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #D8D8D8;
        }
    }
}
</style>
